import React from 'react'
import { observable, action, runInAction } from 'mobx'
import API from '@api/hotel/order'

class Store {
  id
  @observable eat_time = ''

  @observable
  orderInfo = {
    hotel: '',
    orderStatus: '',
    orderNo: '',
    orderFrom: '',
    created_at: '',
    viewed_at: '',
    userName: '',
    userPhone: '',
    userNameTo: '',
    userPhoneTo: '',
    weddingArea: '',
    shopStatus: '',
    weddingTime: '',
    eat_time: '',
    tables: '',
    prices: '',
    remark: '',
    customer: '',
    full_name: []
  }

  @action
  reset = () => {
    this.orderInfo = { full_name: [] }
  }

  @observable hallData = []

  @action
  getHall = async params => {
    let { data } = await API.GetHall(params)
    runInAction('gethall', () => {
      this.hallData = data
    })
  }

  @observable DataHistory = []
  @action
  OrderHiy = async params => {
    let { data } = await API.OrderHiy(params)
    runInAction('OrderHiy', () => {
      this.DataHistory = data.list
    })
  }

  @action
  getHistory = async params => {
    let { data } = await API.OrderHistory(params)
    runInAction('gt', () => {
      this.DataHistory = data.list
    })
  }

  @action
  getA = () => {
    this.GetAssigns('id=' + this.id)
  }

  @observable assigns = []
  @observable
  assignForm = {
    hotel: '暂无',
    fullname: '暂无',
    fullphone: '暂无',
    created_at: '暂无'
  }
  @action
  GetAssigns = async params => {
    let {
      data: { list, created_at }
    } = await API.GetAssigns(params)
    runInAction('gethall', () => {
      this.assigns = list
      if (list.length != 0) {
        let _merName = '暂无'
        let _name = '暂无'
        let _phone = '暂无'
        let _created_at = '暂无'
        if (list.merchant) {
          _name = list.merchant.hotel_saler_setup.map(v => {
            let _p = <p key={v.id}>{v.fullname}</p>
            return _p
          })
          _phone = list.merchant.hotel_saler_setup.map(v => {
            let _p = <p key={v.id}>{v.phone}</p>
            return _p
          })
          _merName = list.merchant.name
        }
        if (created_at) {
          _created_at = created_at
        }
        this.assignForm = {
          hotel: _merName,
          fullname: _name,
          fullphone: _phone,
          created_at: _created_at
        }
      }
    })
  }
  @observable fbStatus = ''
  @observable is_come = '0'
  @observable status = ''
  @action
  getInfo = async params => {
    let {
      data,
      data: {
        status,
        feedback,
        order_no,
        is_come,
        created_at,
        ordered_from,
        viewed_at,
        merchant,
        lead,
        order: {
          remark,
          eat_time,
          city_area,
          price_begin,
          price_end,
          tables_begin,
          tables_end,
          wedding_begin,
          wedding_end
        }
      }
    } = await API.OrderInfo(params)
    runInAction('get', () => {
      if (feedback) {
        this.fbStatus = feedback
      } else {
        this.fbStatus = ''
      }
      this.getStatus(status)
      this.getEat(String(eat_time))
      this.getHall()
      this.is_come = is_come
      this.orderInfo.hotel = merchant.name
      this.orderInfo.orderNo = order_no
      this.orderInfo.orderFrom = ordered_from
      this.orderInfo.created_at = created_at
      this.orderInfo.viewed_at = viewed_at

      this.orderInfo.userName = lead.name
      this.orderInfo.userPhone = lead.phone
      if (lead.user_info) {
        this.orderInfo.userNameTo = lead.user_info.name
        this.orderInfo.userPhoneTo = lead.user_info.phone
      }

      this.orderInfo.weddingArea = city_area

      this.status = status

      this.orderInfo.weddingTime = `${wedding_begin} ~ ${wedding_end}`
      this.orderInfo.tables = `${
        tables_end == 0 ? tables_begin : tables_begin + '~' + tables_end
      }`
      this.orderInfo.prices = `¥${
        price_end == 0 ? price_begin : price_begin + '~¥' + price_end
      }`
      this.orderInfo.remark = remark

      this.orderInfo.full_name = merchant.hotel_saler_setup
      let _ne = '暂无'
      if (data.admin) {
        _ne = data.admin.nickname
      }

      this.orderInfo.customer = _ne

      if (is_come == '0') {
        this.orderInfo.shopStatus = '未到店'
      } else {
        this.orderInfo.shopStatus = '到店'
      }
    })
  }
  @action
  getEat = e => {
    let _status = '暂无'
    if (e.indexOf(',') > -1) {
      _status = '午市及晚市'
    } else {
      switch (e) {
        case '1':
          _status = '午市'
          break
        case '2':
          _status = '晚市'
          break
      }
    }

    this.orderInfo.eat_time = _status
  }
  @action
  getStatus = e => {
    let _status = '暂无'
    switch (String(e)) {
      case '-1':
        _status = '未派单'
        break
      case '0':
        _status = '未查看'
        break
      case '1':
        _status = '已查看'
        break
      case '2':
        _status = '已过期'
        break
      case '3':
        _status = '已查看'
        break
      case '4':
        _status = '跟进失败'
        break
      case '5':
        _status = '定金已付'
        break
      case '6':
        _status = '已退单'
        break
    }

    this.orderInfo.orderStatus = _status
  }
}

export default new Store()
